<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/leandro4.jpeg" 
         data-stellar-background-ratio="0.5" 
         style="background-position: center; background-repeat: no-repeat; background-size: cover; height: 100vh; width: 100%;"
  style="background-image: url('assets/img/leandro4.jpeg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
        <div class="col-md-12 logo_gerencia">
            <img src="/assets/img/logo_grd.png" alt="" class="logo_gerencia_imagen" style="width: 150px;">
        </div>
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white">
          <h3 style="color: white">
            <span class="textodelgado">ISMP</span><br>
            <span class="textogordo">LEANDRO ALVIÑA MIRANDA</span> <br>
            <!-- <span class="textodelgado"> del Centro Histórico del Cusco</span> -->
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- MANUAL DE INTERVENCIÓN -->
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto text-center">
        <div class="section-title-wrap">
          <h2>INTERVENCIÓN EN EL ISMP LEANDRO ALVIÑA MIRANDA</h2>
          <p class="mb-0" style="font-weight: 300;">
           Una parte fundamental de este proyecto implica la intervención en tres inmuebles del <b>Centro Histórico del Cusco</b> que, además de su valor patrimonial, 
           cumplen un rol esencial en la educación de la ciudad. 
           Entre estos se encuentra el <b>Instituto Superior de Música “Leandro Alviña Miranda.”</b>. 
           Esta institución de educación superior tiene como misión la enseñanza y difusión de conocimientos, 
           cultura y tecnología en la formación de profesionales en música, tales como <b>Artistas Músicos y Docentes en Educación Artística.</b>
           El valor arquitectónico de este inmueble se destaca tanto por su ubicación en el barrio de San Blas, 
           una de las zonas de mayor importancia cultural en Cusco, como por los numerosos vestigios y elementos arquitectónicos que 
           alberga en su interior. Su diseño representa una tipología clásica que combina elementos de la arquitectura republicana y virreinal
          </p>
          <br>
        </div>

        <div class="page-wrapper">
            <article class="port-details-page-wrap">
                <div class="port-details-header">
                    <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 3, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/leandro1.jpeg" class="btn-img-gallery">
                                <img src="assets/img/leandro1.jpeg" alt="Portfolio">
                            </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                          <a href="assets/img/leandro2.jpeg" class="btn-img-gallery">
                              <img src="assets/img/leandro2.jpeg" alt="Portfolio">
                          </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/leandro3.jpeg" class="btn-img-gallery">
                                <img src="assets/img/leandro3.jpeg" alt="Portfolio">
                            </a>
                        </figure>
                    </div>
                </div>
            </article>
          </div>

        <div class="col-md-12" style="margin-top: 70px !important;">
            <h3 class="text-center">MANUAL DE INTERVENCIÓN</h3>
            <p class="mb-0" style="font-weight: 300;">
                Este manual ha sido elaborado con la finalidad de proporcionar a profesionales, técnicos y ciudadanos, 
                las herramientas necesarias para llevar a cabo intervenciones adecuadas y respetuosas en los inmuebles de 
                nuestra ciudad; para mitigar los riesgos de desastres a los que nuestro patrimonio está expuesto debido a su alto 
                nivel de vulnerabilidad que presentan en la mayoria de casos.
            </p>
            <div style="display: flex; flex-direction: row; justify-content: center; width: 100%;">
              <a href="https://drive.google.com/uc?export=download&id=1rYoD_aP3OWP6GCzzJndWVzw3_J51k-O3" class="btn btn-brand" target="_blank" style="background-color:#821644;margin-top:30px;">Descargar el Manual de Intervención</a>
            </div>
            <br>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper" style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
            <iframe style="width:100%; height: 700px" src="https://online.anyflip.com/zdbmc/pzhx/index.html" seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>






<!-- BOLETIN -->
<section class="welcome-section pt-80 pt-pd-60 pt-40">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto text-center">
        <div class="col-md-12" style="margin-bottom: 30px !important;">
            <h3 class="text-center">BOLETÍN INFORMATIVO</h3>
            <p class="mb-0" style="font-weight: 300;">
                El boletín informa sobre la intervención en el inmueble del <b>Instituto Superior de Música "Leandro Alviña Miranda"</b> en Cusco, 
                que forma parte del proyecto de gestión de riesgos del Centro Histórico. Destaca la importancia de preservar el valor patrimonial 
                del edificio, que presenta deterioros como daños en muros, techos y carpintería. La intervención incluye restauración, refuerzo estructural y
                 adaptación de espacios para mejorar la seguridad, funcionalidad y enseñanza musical. Además, se crearon nuevos ambientes como salas de uso múltiple y oficinas, 
                 integrando modernidad sin afectar la estética histórica. Todo esto contribuye a proteger el patrimonio y reducir riesgos ante posibles desastres en la zona.
            </p>
            <br>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper" style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <iframe style="width:100%; height: 700px;" src="https://online.anyflip.com/zdbmc/dxrr/index.html" seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>


<section class="welcome-section pt-80 pt-pd-60 pt-40" style="">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-12 m-auto text-center">
        <div class="col-md-12">
            <h3 class="text-center">VISTA 3D DEL ISMP LEANDRO ALVIÑA MIRANDA</h3>
            <p class="mb-0" style="font-weight: 300;">
                En esta representación tridimensional  podrán explorar nuestras instalaciones, 
                que incluyen aulas modernas, talleres equipados y áreas recreativas. Esta visualización permite apreciar 
                la infraestructura diseñada para fomentar el aprendizaje práctico y teórico. 
            </p>
            <br>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="row">
    <iframe src="https://nicext6.autodesk360.com/shares/public/SH30dd5QT870c25f12fc510fd833891b7c76?mode=embed" width="100%" height="700" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"  frameborder="0"></iframe>
</div>

<style>
.logo_gerencia_imagen{
    width: 150px !important;
}
.logo_gerencia{
    display: flex; 
    flex-direction: row; 
    justify-content: center; 
    width: 100px !important; 
    margin-top: 180px !important;
}
.textodelgado{
    font-weight: 100 !important;
    font-size: 25px;
}

.textogordo{
    font-weight: bolder !important;
    font-size: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991.98px), only screen and (max-width: 767.98px){
    .about-us-content {
            font-size: 14px;
            padding: 0px;
    }
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100px !important;
        margin-top: 250px !important;
        margin-bottom: -100px;
    }
}

@media (max-width: 425px){
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100% !important;
        margin-top: 140px !important;
        margin-bottom: 0px;
    }
    .logo_gerencia_imagen{
        width: 100px !important;
    }
    .textodelgado{
        font-weight: 100 !important;
        font-size: 17px;
    }
    .textogordo{
        font-weight: bolder !important;
        font-size: 17px;
    }
}
</style>